import pluralizer from "pluralize";
import humanizeString from "string-humanize";

const urlParser = document.createElement("a");

export function domain(url) {
  urlParser.href = url;
  return urlParser.hostname;
}

export function humanize(str) {
  let result = humanizeString(str);

  // NOTE: can handle special cases here if needed
  return result;
}

export function count(arr) {
  return arr.length;
}

export function pluralize(count, label) {
  return pluralizer(label, count);
}
